export enum NetSuiteQuoteStatus {
  Open = "Open",
  // Client-only bucket: NetSuite has no "pending" status. A quote lands here when
  // its PSQL draft is `pending_sales_order` (a rep requested SO conversion) while
  // its NetSuite estimate is still Open. Overlaid onto the NS row during bucketing.
  PendingSalesOrder = "Pending Sales Order",
  Processed = "Processed",
  Expired = "Expired"
}

export enum NetSuiteEntity {
  Lead = "lead",
  Customer = "customer",
  Prospect = "prospect"
}

export enum NetSuiteEntityStatus {
  // Lead
  Lead_Unqualified = 6,
  Lead_Qualified = 7,

  // Prospect
  Prospect_InDiscussion = 8,
  Prospect_IdentifiedDecisionMakers = 9,
  Prospect_Proposal = 10,
  Prospect_InNegotiation = 11,
  Prospect_Purchasing = 12,

  // Customer
  Customer_ClosedWon = 13,
  Customer_ClosedLost = 14,
  Customer_Renewal = 15,
  Customer_LostCustomer = 16
}
